import { render, staticRenderFns } from "./FilterBottom.vue?vue&type=template&id=ba22200e&"
import script from "./FilterBottom.vue?vue&type=script&lang=js&"
export * from "./FilterBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports